import { createContext as t } from "react";
var o = /* @__PURE__ */ t({
  size: "medium",
  borderBottom: !0
});
export {
  o as T
};
